function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWasherSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "washer_small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon 16px",
    transform: "translate(-1431 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 3697",
    width: 16,
    height: 16,
    rx: 8,
    transform: "translate(1431 13)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.313-868.9a.635.635 0 0 0 .381-.112.349.349 0 0 0 .14-.293.373.373 0 0 0-.143-.31.619.619 0 0 0-.406-.107 2.652 2.652 0 0 1-1.415-.414 2.086 2.086 0 0 1-.927-1.533.433.433 0 0 0-.156-.258.425.425 0 0 0-.271-.1.372.372 0 0 0-.313.151.381.381 0 0 0-.077.326 2.92 2.92 0 0 0 1.217 2.045 3.421 3.421 0 0 0 1.97.605zm-.049 2.062a5.03 5.03 0 0 1-3.759-1.546 5.3 5.3 0 0 1-1.505-3.852 6.511 6.511 0 0 1 1.308-3.578 21.874 21.874 0 0 1 3.956-4.186 21.873 21.873 0 0 1 3.956 4.186 6.511 6.511 0 0 1 1.308 3.578 5.3 5.3 0 0 1-1.505 3.849 5.03 5.03 0 0 1-3.759 1.546zm0-1.1a3.974 3.974 0 0 0 2.983-1.225 4.245 4.245 0 0 0 1.184-3.073 5.39 5.39 0 0 0-1.061-2.873 18.323 18.323 0 0 0-3.106-3.432 18.322 18.322 0 0 0-3.106 3.432 5.39 5.39 0 0 0-1.061 2.873 4.245 4.245 0 0 0 1.184 3.073 3.974 3.974 0 0 0 2.983 1.225zm0-5.482z",
    transform: "translate(1273.736 894.507)",
    style: {
      fill: "#08232f"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasherSmall);
export default __webpack_public_path__ + "static/media/washer_small.ac5b702430276f4c9a784c96310bf792.svg";
export { ForwardRef as ReactComponent };